import { Spinner as BlueprintSpinner } from "@blueprintjs/core";

export const CenterSpinner = () => (
  <div className="container">
    <div className="nav_container"></div>
    <div className="content_container">
      <BlueprintSpinner />
    </div>
  </div>
);

export const Spinner = (props: { disabled?: boolean; sprops?: any }) =>
  props.disabled ? (
    <></>
  ) : (
    <BlueprintSpinner style={{ marginTop: "1em" }} {...props.sprops} />
  );
